class Alert {
    types = ['success', 'danger', 'error'];

    icons = {
        success: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51 52" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M33.8484 6.71861C29.757 4.89556 25.1858 4.44393 20.8167 5.43108C16.4476 6.41822 12.5146 8.79125 9.60437 12.1962C6.69412 15.6012 4.9625 19.8558 4.66778 24.3253C4.37306 28.7948 5.53103 33.2399 7.96898 36.9976C10.4069 40.7552 13.9943 43.6241 18.1959 45.1764C22.3976 46.7287 26.9885 46.8812 31.2839 45.6112C35.5793 44.3412 39.3491 41.7167 42.0311 38.1291C44.713 34.5415 46.1635 30.1831 46.166 25.7039V23.5819C46.166 22.3072 47.1993 21.2739 48.474 21.2739C49.7486 21.2739 50.7819 22.3072 50.7819 23.5819V25.7052C50.7788 31.1798 49.0061 36.5081 45.7281 40.8929C42.4502 45.2777 37.8426 48.4854 32.5927 50.0377C27.3427 51.5899 21.7316 51.4035 16.5963 49.5063C11.4609 47.609 7.07639 44.1026 4.09667 39.5099C1.11695 34.9172 -0.298345 29.4843 0.061868 24.0216C0.422081 18.5588 2.5385 13.3588 6.09548 9.19718C9.65246 5.03552 14.4594 2.13515 19.7994 0.928646C25.1395 -0.277862 30.7264 0.274132 35.7271 2.5023C36.8914 3.02109 37.4147 4.3855 36.8959 5.5498C36.3772 6.7141 35.0127 7.2374 33.8484 6.71861ZM50.1051 5.60874C51.0069 6.50961 51.0076 7.97092 50.1068 8.87269L27.0272 31.9754C26.5944 32.4085 26.0073 32.652 25.395 32.6522C24.7827 32.6523 24.1954 32.4091 23.7624 31.9762L16.8385 25.0523C15.9372 24.151 15.9372 22.6897 16.8385 21.7883C17.7399 20.887 19.2012 20.887 20.1025 21.7883L25.3936 27.0794L46.8412 5.61037C47.7421 4.70861 49.2034 4.70788 50.1051 5.60874Z" fill="#45786F"/>
</svg>`,
        danger: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 51" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M25.8 4.6C14.3677 4.6 5.1 13.8677 5.1 25.3C5.1 36.7323 14.3677 46 25.8 46C37.2323 46 46.5 36.7323 46.5 25.3C46.5 13.8677 37.2323 4.6 25.8 4.6ZM0.5 25.3C0.5 11.3272 11.8272 0 25.8 0C39.7728 0 51.1 11.3272 51.1 25.3C51.1 39.2728 39.7728 50.6 25.8 50.6C11.8272 50.6 0.5 39.2728 0.5 25.3ZM17.2737 16.7737C18.1719 15.8755 19.6281 15.8755 20.5263 16.7737L25.8 22.0473L31.0737 16.7737C31.9719 15.8755 33.4281 15.8755 34.3263 16.7737C35.2246 17.6719 35.2246 19.1281 34.3263 20.0263L29.0527 25.3L34.3263 30.5737C35.2246 31.4719 35.2246 32.9281 34.3263 33.8263C33.4281 34.7246 31.9719 34.7246 31.0737 33.8263L25.8 28.5527L20.5263 33.8263C19.6281 34.7246 18.1719 34.7246 17.2737 33.8263C16.3755 32.9281 16.3755 31.4719 17.2737 30.5737L22.5473 25.3L17.2737 20.0263C16.3755 19.1281 16.3755 17.6719 17.2737 16.7737Z" fill="#DF7A5E"/>
</svg>`,
    };

    constructor({type = "success", title = "", message = ""}) {
        if (!this.types.includes(type))
            throw Error('Wrong alert type!');

        if (type === 'error')
            type = 'danger';

        this.element = this.createElement({
            icon: this.icons[type],
            title,
            message,
            type
        });
    }

    createElement({icon, message, title, type}) {
        const element = document.createElement('div');
        element.className = `tatox-alert show tatox-alert-${type}`;
        element.innerHTML = `
                <div class="alert-wrapper">
                    <div class="alert-header">
                        <strong>${title}</strong>
                    </div>
                    <div class="alert-body">
                        <div class="alert-icon">
                            ${icon}
                        </div>
                        <div class="alert-message">
                            <span>${message}</span>
                        </div>
                    </div>
                </div>
        `;

        return element;
    }

    hide(time = 0) {
        if (!time)
            return this.element.classList.remove('show');

        setTimeout(() => {
            this.hide();
        }, time * 1000);
    }

    remove(time = 0) {
        if (!time)
            return this.element.remove();

        setTimeout(() => {
            this.remove();
        }, time * 1000);
    }
}

module.exports = Alert;
